import { render } from "./DCard.vue?vue&type=template&id=5fd051e0&scoped=true"
import script from "./DCard.vue?vue&type=script&lang=js"
export * from "./DCard.vue?vue&type=script&lang=js"

import "./DCard.vue?vue&type=style&index=0&id=5fd051e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd051e0"]])

export default __exports__